<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Genişletilmiş Siparişler ({{ richOrders.length }})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="purple lighten-2" @click="openFraudModal" dark class="mr-2">
        <v-icon left>warning</v-icon>
        Fraud Emaili Hazırla
      </v-btn>
      <v-btn color="success" @click="openExcelModal" dark>
        <v-icon left>table_chart</v-icon>
        Excel Raporu Al
      </v-btn>
    </v-toolbar>

    <!-- Filters -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <!-- Date Filters Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="startDate" label="Başlangıç Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="endDate" label="Bitiş Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-text-field v-model="searchQuery" @keyup.enter.native="search" label="Ara" clearable
                append-icon="search"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-btn color="primary" block @click="search" class="mt-3">
                <v-icon left>search</v-icon>
                Ara
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Additional Filters Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox v-model="selectedOrderState" :items="this.$store.getters['orders/getStateItems']"
                item-value="id" item-text="value" label="Sipariş Durumu" @change="search" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox v-model="selectedMpStatus" :items="this.$store.getters['orders/getHbStateItems']"
                item-value="id" item-text="value" label="MP Sipariş Durumu" @change="search" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox v-model="selectedBank" :items="bankOptions" item-value="id" item-text="value"
                label="Banka Adı" @change="search" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox v-model="selectedEligibility" :items="eligibilityOptions" item-value="id" item-text="value"
                label="Uygunluk Durumu" @change="search" clearable></v-combobox>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Rich Orders Table -->
    <v-data-table :headers="headers" :items="richOrders" :loading="loading" :pagination.sync="pagination"
      :rows-per-page-items="pageItems" class="elevation-1">
      <template v-slot:headers="props">
        <tr>
          <th v-for="header in props.headers" :key="header.text" class="px-1 text-xs-left" :class="[
            'column sortable',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '',
          ]" @click="changeSort(header.value)">
            {{ header.text }}
            <v-icon small v-if="header.sortable !== false">arrow_upward</v-icon>
          </th>
        </tr>
      </template>

      <template v-slot:items="props">
        <tr class="ro-row" :class="{
          'grey lighten-3': props.item.isLocked,
          'ro-row-danger': !props.item.isEligibleForCompletion,
          'purple lighten-5': props.item.isSentForFraud
        }">
          <td class="px-2 py-3">
            <div class="ro-customer">
              <div class="ro-customer-name">{{ props.item.customerName }}</div>
              <div class="ro-customer-sub">{{ props.item.email }}</div>
              <div class="ro-customer-mono">{{ props.item.phoneNumber }}</div>
              <div class="ro-customer-mono" v-if="props.item.identityNo">TC: {{ props.item.identityNo }}</div>
            </div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-iban">
              <div class="ro-iban-chip" @click="copyIbanToClipboard(props.item.ibanFull || props.item.ibanMasked)">
                {{ props.item.ibanMasked }}
              </div>
              <div class="ro-bank-pill" :class="props.item.bankName ? 'ro-bank-ok' : 'ro-bank-missing'">
                {{ props.item.bankName ? ('Anlaşmalı ' + props.item.bankName) : "IBAN'dan banka bulunamadı" }}
              </div>
            </div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-order">
              <div class="ro-order-mono">{{ props.item.orderNumber }}</div>
              <div class="ro-order-sub">{{ props.item.orderDateTime | formatDate }}</div>
              <div class="ro-order-sub">Gram: <span class="ro-strong">{{ Number(props.item.orderGrams || 0).toFixed(4)
                  }}</span></div>
              <div class="ro-order-sub">Bankaya: <span class="ro-strong">{{ (props.item.isEligibleForCompletion ?
                Number(props.item.gramsToSendToBank || 0) : 0).toFixed(4) }}</span></div>
            </div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-product">{{ props.item.productName }}</div>
            <div class="ro-product-sub" v-if="props.item.hasAverage !== null && props.item.hasAverage !== undefined">
              Has: {{ props.item.hasAverage | formatMoney }}
            </div>
          </td>

          <td class="px-2 py-3 text-xs-right">
            <div class="ro-amount">
              <div class="ro-amount-main">{{ props.item.unitPrice | formatMoney }}</div>
              <div class="ro-amount-sub">{{ props.item.quantity }} adet</div>
            </div>
          </td>

          <td class="px-2 py-3 text-xs-right">
            <div class="ro-total">{{ props.item.invoiceAmount | formatMoney }}</div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-status-pill ro-status-cargo">
              {{ props.item.orderState | formatState }}
            </div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-status-pill ro-status-mp">
              {{ props.item.mpOrderStatus | formatHbState }}
            </div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-completed">
              <div class="ro-completed-by" :class="!props.item.completedBy ? 'ro-muted' : ''">
                {{ props.item.completedBy || '-' }}
              </div>
              <div v-if="props.item.completedDate" class="ro-completed-date">
                {{ props.item.completedDate | formatDate }}
              </div>
            </div>
          </td>

          <td class="px-2 py-3">
            <div v-if="props.item.orderSuccessRate" class="ro-success-rate">
              <span class="ro-success-ok">{{ props.item.orderSuccessRate.successfulOrdersOfCustomer || 0 }} başarılı</span>
              <span class="ro-success-fail">{{ props.item.orderSuccessRate.unSuccessfulOrdersOfCustomer || 0 }} başarısız</span>
            </div>
            <div v-else class="ro-muted">-</div>
          </td>

          <td class="px-2 py-3">
            <div class="ro-actions">
              <button class="ro-action-btn ro-action-blue" :disabled="props.item.isLocked"
                @click="processOrder(props.item)" title="İşlem Yap">
                <span class="material-icons">edit</span>
              </button>
              <button class="ro-action-btn ro-action-green" @click.stop="invoicePrintRow(props.item)"
                title="Faturayı Yazdır">
                <span class="material-icons">receipt_long</span>
              </button>
              <button class="ro-action-btn ro-action-orange" @click.stop="resendInvoiceRow(props.item)"
                title="Faturayı Tekrar Aktar">
                <span class="material-icons">autorenew</span>
              </button>
            </div>
            <div v-if="props.item.isLocked" class="ro-locked-by">
              {{ props.item.lockedByUserName || props.item.lockedByUser }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- Order Processing Modal -->
    <v-dialog v-model="orderDialog" max-width="1200px" @input="onDialogChange" persistent>
      <v-card v-if="currentOrders.length > 0" class="order-modal">
        <!-- Modern Header with Gradient -->
        <v-card-title class="headline white--text primary darken-1 elevation-2">
          <v-icon left color="white" size="28">receipt</v-icon>
          <span class="font-weight-bold">Sipariş Detayları</span>
          <v-spacer></v-spacer>

          <!-- Fraud Flag Switch -->
          <div v-if="anyItemSentForFraud" class="mr-4" style="display: flex; align-items: center;">
            <span class="mr-2 caption font-weight-bold">Fraud İşaretli</span>
            <v-switch v-model="fraudFlagActive" :disabled="!fraudFlagActive" @change="handleFraudSwitchChange"
              color="purple lighten-3" hide-details class="mt-0 pt-0"></v-switch>
          </div>

          <v-btn icon dark @click="closeModal" :loading="closeLoading" :disabled="shippingLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <!-- Müşteri Bilgileri Section -->
            <v-card class="mb-4 modern-card" outlined>
              <v-card-title class="subtitle-1 primary--text py-2">
                <v-icon left color="primary">person</v-icon>
                Müşteri Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Müşteri Adı</div>
                    <div class="body-2 font-weight-medium">{{ currentOrders[0].customerName }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Sipariş No</div>
                    <div class="body-2 font-weight-medium">{{ currentOrders[0].orderNumber }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Sipariş Tarihi</div>
                    <div class="body-2">{{ currentOrders[0].orderDateTime | formatDate }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Tamamlanabilme Durumu</div>
                    <div
                      :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold' : 'body-2 success--text font-weight-bold'">
                      {{ isOrderEligibleForCompletion ? 'UYGUN' : 'UYGUN DEĞİL' }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <!-- IBAN Bazlı Gruplar -->
            <v-card v-for="(group, groupIndex) in groupedOrders" :key="groupIndex" class="mb-4 modern-card" outlined>
              <!-- Banka Bilgileri -->
              <v-card-title
                :class="!isOrderEligibleForCompletion ? 'subtitle-1 red--text py-2' : 'subtitle-1 primary--text py-2'">
                <v-icon left :color="!isOrderEligibleForCompletion ? 'red' : 'primary'">account_balance</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">Banka Adı</div>
                    <div class="body-2">{{ group.bankName || 'Bulunamadı' }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">IBAN</div>
                    <div
                      :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold clickable-iban' : 'body-2 success--text font-weight-bold clickable-iban'"
                      @click="copyIbanToClipboard(group.iban)"
                      :title="'IBAN\'ı kopyalamak için tıklayın: ' + group.iban">
                      <v-icon small class="mr-1">content_copy</v-icon>
                      {{ group.iban }}
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">Toplam Gönderilecek Altın Gramı</div>
                    <div
                      :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold' : 'body-2 success--text font-weight-bold'">
                      {{ !isOrderEligibleForCompletion ? '0.00' : group.totalGramsToSend.toFixed(2) }} gr
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="!isOrderEligibleForCompletion">
                    <v-alert color="error" dense border="left" colored-border class="mt-3 mb-0 white--text"
                      style="background-color: #f44336 !important;">
                      <strong>⚠ Bu sipariş tamamlanmaya uygun değildir.</strong>
                    </v-alert>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <!-- Her item için Ürün ve Tutar Bilgileri -->
              <div v-for="(item, itemIndex) in group.items" :key="'item-' + groupIndex + '-' + itemIndex">
                <v-divider class="mx-4"></v-divider>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">shopping_cart</v-icon>
                  Ürün ve Tutar Bilgileri {{ group.items.length > 1 ? '(' + (itemIndex + 1) + ')' : '' }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text">Ürün</div>
                      <div class="body-2 font-weight-medium">{{ item.productName }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Miktar</div>
                      <div class="body-2">{{ item.quantity }} adet</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Ürün Gram</div>
                      <div class="body-2">{{ item.orderGrams }} gr</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Bankaya Gönderilecek</div>
                      <div class="body-2">{{ item.gramsToSendToBank.toFixed(4) }} gr</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Birim Fiyat</div>
                      <div class="body-2">{{ item.unitPrice | formatMoney }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Fatura Tutarı</div>
                      <div class="body-2">{{ item.invoiceAmount | formatMoney }}</div>
                    </v-flex>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text mb-2">Notlar</div>
                      <div v-for="(note, noteIndex) in item.notes" :key="noteIndex"
                        :class="note.includes('Anlaşmalı Banka') && !note.includes('Değil') ? 'green--text' : 'red--text'"
                        class="body-2 font-weight-medium mb-1">
                        • {{ note }}
                      </div>
                    </v-flex>

                    <v-flex xs12 class="py-2 mt-3">
                      <v-divider class="mb-3"></v-divider>
                      <div v-if="!ibanUpdateState[item.orderItemId] || !ibanUpdateState[item.orderItemId].showInput">
                        <v-btn small color="warning" @click="showIbanInput(item.orderItemId, item.ibanFull)">
                          <v-icon left small>edit</v-icon>
                          IBAN Değiştir
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-text-field v-model="ibanUpdateState[item.orderItemId].newIban" label="Yeni IBAN" outlined
                          dense maxlength="26" counter :disabled="ibanUpdateState[item.orderItemId].loading"
                          @keyup.enter="updateItemIban(item)"></v-text-field>
                        <v-btn small color="success" @click="updateItemIban(item)"
                          :loading="ibanUpdateState[item.orderItemId].loading"
                          :disabled="ibanUpdateState[item.orderItemId].loading" class="mr-2">
                          <v-icon left small>check</v-icon>
                          Tamam
                        </v-btn>
                        <v-btn small color="grey" text @click="ibanUpdateState[item.orderItemId].showInput = false"
                          :disabled="ibanUpdateState[item.orderItemId].loading">
                          İptal
                        </v-btn>
                      </div>
                    </v-flex>

                    <!-- Order Item Notes Section -->
                    <v-flex xs12 class="py-2 mt-3">
                      <v-divider class="mb-3"></v-divider>

                      <!-- Display existing note -->
                      <div
                        v-if="item.orderItemNotes && (!notesUpdateState[item.orderItemId] || !notesUpdateState[item.orderItemId].showTextarea)">
                        <div class="subtitle-2 primary--text mb-2">
                          <v-icon small color="primary" class="mr-1">note</v-icon>
                          Sipariş Kalemi Notu
                        </div>
                        <div style="position: relative;">
                          <v-card outlined class="pa-3 note-display-card modern-subcard">
                            <div class="body-2" style="padding-right: 32px;">{{ item.orderItemNotes }}</div>
                          </v-card>
                          <v-btn icon small color="primary" class="note-edit-btn"
                            @click="showNotesTextarea(item.orderItemId, item.orderItemNotes)">
                            <v-icon small>edit</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <!-- Add note button -->
                      <div
                        v-if="!item.orderItemNotes && (!notesUpdateState[item.orderItemId] || !notesUpdateState[item.orderItemId].showTextarea)">
                        <div class="subtitle-2 grey--text mb-2">
                          <v-icon small color="grey" class="mr-1">note</v-icon>
                          Sipariş Kalemi Notu
                        </div>
                        <v-btn small color="info" outlined @click="showNotesTextarea(item.orderItemId, '')">
                          <v-icon left small>add</v-icon>
                          Not Ekle
                        </v-btn>
                      </div>

                      <!-- Textarea for editing -->
                      <div v-if="notesUpdateState[item.orderItemId] && notesUpdateState[item.orderItemId].showTextarea">
                        <div class="subtitle-2 primary--text mb-2">
                          <v-icon small color="primary" class="mr-1">edit_note</v-icon>
                          Not Düzenle
                        </div>
                        <v-textarea v-model="notesUpdateState[item.orderItemId].notes" outlined dense rows="4"
                          maxlength="500" counter :disabled="notesUpdateState[item.orderItemId].loading"
                          placeholder="Notunuzu buraya yazın..."></v-textarea>
                        <v-btn small color="success" @click="updateItemNotes(item)"
                          :loading="notesUpdateState[item.orderItemId].loading"
                          :disabled="notesUpdateState[item.orderItemId].loading" class="mr-2">
                          <v-icon left small>save</v-icon>
                          Kaydet
                        </v-btn>
                        <v-btn small color="grey" text class="white--text"
                          @click="notesUpdateState[item.orderItemId].showTextarea = false"
                          :disabled="notesUpdateState[item.orderItemId].loading">
                          İptal
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
          </v-container>
        </v-card-text>

        <v-card class="mx-4 mb-4 receipt-shell" outlined>
          <div class="receipt-header">
            <div class="receipt-header-left">
              <div class="receipt-icon">
                <v-icon color="primary">attachment</v-icon>
              </div>
              <div>
                <div class="receipt-title">Referans / Dekont Yönetimi</div>
                <div class="receipt-subtitle">Ödeme makbuzlarınızı buradan yükleyebilir ve yönetebilirsiniz.</div>
              </div>
            </div>
            <div class="receipt-status d-none d-sm-flex">
              <span class="receipt-dot"></span>
              Sistem Aktif
            </div>
          </div>

          <div class="receipt-body">
            <input ref="receiptFileInput" type="file" accept="application/pdf,image/*" style="display: none"
              @change="onReceiptFileSelected" />

            <v-layout wrap>
              <v-flex xs12 md6 v-if="showReferenceSection" class="pr-md-3 mb-4">
                <div class="ref-shell">
                  <div class="ref-header">
                    <v-icon class="ref-header-icon">local_offer</v-icon>
                    <div class="ref-header-title">REFERANS</div>
                  </div>

                  <div class="ref-row">
                    <label class="ref-label">
                      <span class="ref-label-text">Referans No</span>
                      <div class="ref-input-wrap">
                        <v-icon class="ref-input-icon">push_pin</v-icon>
                        <input v-model="referenceNumber" class="ref-input" type="text"
                          placeholder="Referans numaranızı girin" :disabled="referenceSent || referenceSending"
                          @keyup.enter="handleReferenceSend" />
                      </div>
                    </label>

                    <v-btn class="ref-send-btn" dark depressed :loading="referenceSending" :disabled="referenceSent"
                      @click="handleReferenceSend">
                      <span class="ref-send-text">{{ isReferenceRequired ? 'GÖNDER' : 'EKLE' }}</span>
                      <v-icon right>send</v-icon>
                    </v-btn>
                  </div>

                  <div class="ref-footnote">
                    Girdiğiniz referans numarasının doğruluğundan emin olun.
                  </div>

                  <div v-if="referenceSent" class="ref-success">
                    <v-icon small color="success" class="mr-1">check_circle</v-icon>
                    {{ isReferenceRequired ? 'Referans gönderildi' : 'Referans eklendi' }}
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 :md="showReferenceSection ? 6 : 12" class="pl-md-3 mb-4">
                <div class="receipt-section-title">Dekont</div>
                <div class="receipt-section-subtitle">Dosyayı sürükleyin veya göz atmak için tıklayın.</div>

                <div class="receipt-dropzone" @click="triggerReceiptInput">
                  <div class="receipt-dropzone-icon">
                    <v-icon color="white" size="28">cloud_upload</v-icon>
                  </div>
                  <div class="receipt-dropzone-title">DEKONT YÜKLE</div>
                  <div class="receipt-dropzone-desc">PDF, JPG, PNG (Max. 10MB)</div>
                </div>

                <div class="mt-4">
                  <div v-if="hasReceipt" class="receipt-count-pill">
                    <v-icon small class="mr-2">check_circle</v-icon>
                    {{ receiptKeys.length }} dekont yüklü
                  </div>
                  <v-alert v-else type="error" dense border="left" class="mb-0">
                    Dekont zorunlu
                  </v-alert>
                </div>
              </v-flex>
            </v-layout>

            <div v-if="hasReceipt" class="receipt-list-shell mt-6">
              <div class="receipt-list-header">
                <div class="receipt-list-title">Yüklenen Dekontlar</div>
                <div class="receipt-list-hint">Dosya Detayları &amp; İşlemler</div>
              </div>

              <div class="receipt-items">
                <div v-for="(key, idx) in receiptKeys" :key="key" class="receipt-item">
                  <div class="receipt-item-left">
                    <div class="receipt-file-icon">
                      <v-icon color="primary">description</v-icon>
                    </div>
                    <div class="receipt-file-meta">
                      <div class="receipt-file-name" :title="getReceiptFileName(key)">
                        {{ (idx + 1) + '. ' + getReceiptFileName(key) }}
                      </div>
                    </div>
                  </div>

                  <div class="receipt-item-actions">
                    <v-btn icon small class="receipt-icon-btn" @click.stop="copyReceiptLink(key)" :title="'Kopyala'">
                      <v-icon>content_copy</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      class="receipt-icon-btn"
                      :loading="!!receiptDeleting[key]"
                      :disabled="receiptUploading || !!receiptDeleting[key]"
                      @click.stop="deleteReceipt(key)"
                      :title="'Sil'">
                      <v-icon color="error">delete</v-icon>
                    </v-btn>
                    <v-btn small class="receipt-open-btn" @click.stop="openReceipt(key)" :title="'Dosyayı Aç'">
                      <span class="receipt-open-text">AÇMAK İÇİN TIKLAYIN</span>
                      <v-icon right small>open_in_new</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>

        <!-- Action Buttons -->
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-card v-if="canCompleteOrder" outlined class="pa-3 mr-4 modern-dashed-card">
            <div class="d-flex align-center mb-2">
              <v-icon color="primary" class="mr-2">payments</v-icon>
              <span class="subtitle-2 font-weight-bold">Banka Nakit Düşümü</span>
              <v-spacer></v-spacer>
              <span class="caption red--text font-weight-bold">*</span>
            </div>
            <v-text-field v-model.number="bankCashDeductionAmount" label="Düşülecek Tutar" placeholder="Örn: 123,58"
              type="number" step="0.01" min="-1" :disabled="shippingLoading || closeLoading" :rules="cashDeductionRules"
              hide-details="auto" dense outlined color="primary" prepend-inner-icon="payments" suffix="₺"
              hint="Tamamla butonuna basmadan önce düşülecek TL tutarını giriniz." persistent-hint></v-text-field>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeModal" :loading="closeLoading" :disabled="shippingLoading"
            class="px-4 white--text">
            <v-icon left>close</v-icon>
            Kapat
          </v-btn>
          <v-btn
            :color="(!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'error' : 'success'"
            depressed @click="setShippingStatus" :loading="shippingLoading"
            :disabled="closeLoading || !canCompleteOrder || !isCashDeductionValid" class="px-4">
            <v-icon left>{{ (!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'block' :
              'local_shipping' }}</v-icon>
            {{ (!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'Tamamlanamaz' :
              'Tamamla'
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Fraud Orders Modal -->
    <v-dialog v-model="fraudDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="headline white--text purple lighten-2 elevation-2">
          <v-icon left color="white" size="28">warning</v-icon>
          <span class="font-weight-bold">Fraud Kontrol - Şüpheli Siparişler</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeFraudModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-container v-if="fraudLoading" class="text-center py-5">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <div class="mt-3 title">Siparişler kontrol ediliyor...</div>
          </v-container>

          <v-container v-else-if="!fraudLoading && (!fraudOrders || fraudOrders.length === 0)">
            <div
              style="background: #e8f5e9; border-left: 4px solid #4caf50; padding: 24px; margin: 16px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 12px;">
                <v-icon large color="success" style="margin-right: 12px;">check_circle</v-icon>
                <h2 style="color: #2e7d32; margin: 0; font-size: 24px; font-weight: 500;">Şüpheli sipariş bulunamadı
                </h2>
              </div>
              <p style="color: #1b5e20; font-size: 16px; margin: 8px 0 8px 48px;">
                Tüm siparişler normal limitlerin içerisinde.
              </p>
              <p style="color: #66bb6a; font-size: 14px; margin: 4px 0 0 48px;">
                Fraud kontrolü tamamlandı.
              </p>
            </div>
          </v-container>

          <v-container v-else-if="!fraudLoading && fraudOrders && fraudOrders.length > 0">
            <div
              style="background: #fff3e0; border-left: 4px solid #ff9800; padding: 20px; margin-bottom: 10px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <v-icon large color="warning" style="margin-right: 12px;">warning</v-icon>
                <h2 style="color: #e65100; margin: 0; font-size: 22px; font-weight: 500;">{{ fraudOrders.length }} adet
                  şüpheli sipariş tespit edildi!</h2>
              </div>
              <p style="color: #ef6c00; font-size: 15px; margin: 4px 0 0 48px;">
                Aşağıdaki siparişler belirlenen limiti aşmaktadır.
              </p>
            </div>

            <v-data-table :headers="fraudHeaders" :items="fraudOrders" :rows-per-page-items="[10, 25, 50]"
              class="elevation-1">
              <template v-slot:items="props">
                <tr>
                  <td class="px-1">{{ props.item.orderNumber }}</td>
                  <td class="px-1 error--text font-weight-bold">{{ props.item.totalAmount | formatMoney }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeFraudModal" class="px-4 white--text">
            <v-icon left>close</v-icon>
            Kapat
          </v-btn>
          <v-btn v-if="!emailPrepared && fraudOrders.length > 0" color="primary" depressed @click="prepareEmail"
            class="px-4">
            <v-icon left>email</v-icon>
            Email'i Hazırla
          </v-btn>
          <v-btn v-if="emailPrepared" color="success" depressed @click="markAsSent" class="px-4">
            <v-icon left>check</v-icon>
            Email'i Yolladım
          </v-btn>
          <v-btn v-if="emailPrepared" color="warning" text @click="emailPrepared = false" class="px-4">
            <v-icon left>close</v-icon>
            Email'i Yollamadım
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Excel Export Modal -->
    <v-dialog v-model="excelDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline white--text success elevation-2">
          <v-icon left color="white" size="28">table_chart</v-icon>
          <span class="font-weight-bold">Excel Raporu</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeExcelModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container>
            <v-layout wrap>
              <v-flex xs12 class="mb-3">
                <v-menu v-model="excelStartDateMenu" :close-on-content-click="false" lazy transition="scale-transition"
                  offset-y full-width min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="excelStartDate" label="Başlangıç Tarihi" prepend-icon="event" readonly
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="excelStartDate" locale="tr-TR"
                    @input="excelStartDateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12>
                <v-menu v-model="excelEndDateMenu" :close-on-content-click="false" lazy transition="scale-transition"
                  offset-y full-width min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="excelEndDate" label="Bitiş Tarihi" prepend-icon="event" readonly
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="excelEndDate" locale="tr-TR"
                    @input="excelEndDateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeExcelModal" class="px-4">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn color="success" depressed @click="exportToExcel" :disabled="!excelStartDate || !excelEndDate"
            :loading="excelLoading" class="px-4">
            <v-icon left>cloud_download</v-icon>
            Excel'e Aktar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authenticationService } from "@/_services";
import Api from "@/api/baseApi";
import ordersApi from "@/api/orders";
import richOrdersApi from "@/api/richOrders";
import axios from "axios";

export default {
  data() {
    return {
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      searchQuery: '',
      selectedOrderState: { id: -1, value: 'Tümü' },
      selectedMpStatus: { id: '', value: 'Tümü' },
      selectedBank: { id: '-1', value: 'Tümü' },
      selectedEligibility: { id: 'all', value: 'Tümü' },
      loading: false,
      orderDialog: false,
      fraudDialog: false,
      fraudOrders: [],
      fraudLoading: false,
      emailPrepared: false,
      fraudHeaders: [
        { text: 'Sipariş Numarası', value: 'orderNumber' },
        { text: 'Toplam Tutar', value: 'totalAmount' },
      ],
      excelDialog: false,
      excelStartDate: null,
      excelEndDate: null,
      excelStartDateMenu: false,
      excelEndDateMenu: false,
      excelLoading: false,
      invoicePrintLoadingStates: {},
      invoiceResendLoadingStates: {},
      currentOrders: [],
      referenceNumber: "",
      referenceSending: false,
      referenceSent: false,
      receiptUploading: false,
      receiptDeleting: {},
      refreshInterval: null,
      shippingLoading: false,
      closeLoading: false,
      bankCashDeductionAmount: null,
      tenantId: null,
      mpId: null,
      cashDeductionRules: [
        v => (v !== null && v !== undefined && v !== '') || 'Nakit düşümü zorunludur',
        v => (Number(v) >= 0) || 'Nakit düşümü 0’dan düşük olamaz'
      ],
      fraudFlagActive: false,
      ibanUpdateState: {},
      notesUpdateState: {},
      pagination: {
        sortBy: 'orderDateTime',
        descending: true
      },
      pageItems: [
        25,
        50,
        100,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ],
      bankOptions: [
        { id: '-1', value: 'Tümü' }
      ],
      eligibilityOptions: [
        { id: 'all', value: 'Tümü' },
        { id: 'eligible', value: 'Uygun' },
        { id: 'not-eligible', value: 'Uygun Değil' }
      ],
      headers: [
        { text: 'Müşteri', value: 'customerInfo', sortable: false },
        { text: 'IBAN & Banka', value: 'ibanBank', sortable: false },
        { text: 'Sipariş', value: 'orderNumber' },
        { text: 'Ürün', value: 'productName' },
        { text: 'Tutar', value: 'unitPrice' },
        { text: 'Toplam', value: 'invoiceAmount' },
        { text: 'Kargo Durumu', value: 'orderState', sortable: false },
        { text: 'MP Durumu', value: 'mpOrderStatus', sortable: false },
        { text: 'Tamamlayan Kişi', value: 'completedBy', sortable: false },
        { text: 'Başarılı / Başarısız', value: 'orderSuccessRate', sortable: false },
        { text: 'İşlemler', value: 'action', sortable: false },
      ]
    };
  },
  computed: {
    richOrders() {
      return this.$store.getters['richOrders/richOrders'];
    },
    isOrderEligibleForCompletion() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return true;
      }
      return this.currentOrders.every(order => order.isEligibleForCompletion);
    },
    groupedOrders() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return [];
      }

      const groups = {};
      this.currentOrders.forEach(order => {
        const iban = order.ibanFull || 'UNKNOWN';
        if (!groups[iban]) {
          groups[iban] = {
            iban: order.ibanFull,
            ibanMasked: order.ibanMasked,
            bankName: order.bankName,
            customerName: order.customerName,
            orderDateTime: order.orderDateTime,
            orderNumber: order.orderNumber,
            items: []
          };
        }
        groups[iban].items.push(order);
      });

      return Object.values(groups).map(group => ({
        ...group,
        totalGramsToSend: group.items.reduce((sum, item) => sum + item.gramsToSendToBank, 0)
      }));
    },
    anyItemSentForFraud() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return false;
      }
      return this.currentOrders.some(order => order.isSentForFraud);
    },

    isOrderStateNewOrder() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return false;
      }
      return this.currentOrders[0].orderState === 0;
    },

    receiptKeys() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return [];
      }
      const keys = this.currentOrders[0].receipts;
      return Array.isArray(keys) ? keys : [];
    },
    hasReceipt() {
      return this.receiptKeys.length > 0;
    },
    showReferenceSection() {
      return true;
    },
    isReferenceRequired() {
      return Number(this.mpId) === 4;
    },
    canCompleteOrder() {
      const baseOk = this.isOrderEligibleForCompletion && !this.anyItemSentForFraud && this.isOrderStateNewOrder;
      if (!baseOk) return false;
      if (!this.hasReceipt) return false;
      if (this.isReferenceRequired) return this.referenceSent;
      return true;
    },
    isCashDeductionValid() {
      const hasValue =
        this.bankCashDeductionAmount !== null &&
        this.bankCashDeductionAmount !== undefined &&
        this.bankCashDeductionAmount !== '';
      if (!hasValue) return false;
      return Number(this.bankCashDeductionAmount) >= 0;
    }
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;
    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem("tenantId");
    this.mpId = selectedMp || (currentUser && currentUser.mpId);
    await this.loadBanks();
    await this.search();
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async invoicePrintRow(orderRow) {
      if (!orderRow || !orderRow.orderNumber) {
        return;
      }
      this.$set(this.invoicePrintLoadingStates, orderRow.id, true);
      try {
        const response = await Api.get(
          `/api/orders?v=1&q=${encodeURIComponent(orderRow.orderNumber)}`
        );
        const orders = (response && response.data) ? response.data : [];
        const found =
          orders.find(o => Number(o.id) === Number(orderRow.id)) ||
          orders.find(o => o.packageNumber === orderRow.orderNumber) ||
          orders[0];

        if (!found) {
          this.$store.state.dialog = true;
          this.$store.state.message = "Fatura yazdırmak için sipariş bulunamadı.";
          return;
        }

        sessionStorage.setItem("invoiceprint", JSON.stringify([found]));
        window.open("order/invoiceprint", "_blank");
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Fatura yazdırılırken bir hata oluştu.";
      } finally {
        this.$set(this.invoicePrintLoadingStates, orderRow.id, false);
      }
    },

    async resendInvoiceRow(orderRow) {
      if (!orderRow) {
        return;
      }
      this.$set(this.invoiceResendLoadingStates, orderRow.id, true);
      try {
        await this.$store.dispatch("orders/reSendInvoice", {
          selectedItems: [{ id: orderRow.id }],
          stateId: 0,
          isInvoiceReSend: true,
        });
        this.$store.state.dialog = true;
        this.$store.state.message = "Fatura tekrar aktarımına gönderildi.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Fatura tekrar aktarılırken bir hata oluştu.";
      } finally {
        this.$set(this.invoiceResendLoadingStates, orderRow.id, false);
      }
    },

    async sendReferenceNumber(packageNumber, referenceNumber) {
      const ref = (referenceNumber || "").trim();
      if (!packageNumber) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Paket numarası bulunamadı.";
        return false;
      }
      if (!ref) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen referans numarası giriniz.";
        return false;
      }
      try {
        await ordersApi.sendReferenceNumberToIdefix(packageNumber, ref);
        return true;
      } catch (error) {
        return false;
      }
    },

    async handleReferenceSend() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return;
      }
      if (this.referenceSent) {
        return;
      }
      const ref = (this.referenceNumber || "").trim();
      if (!ref) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen referans numarası giriniz.";
        return;
      }
      const orderNumber = this.currentOrders[0].orderNumber;
      this.referenceSending = true;
      try {
        await richOrdersApi.setReferenceNo(orderNumber, ref);

        if (this.isReferenceRequired) {
          const packageNumber = this.currentOrders[0].packageNumber;
          const ok = await this.sendReferenceNumber(packageNumber, ref);
          if (ok) {
            this.referenceSent = true;
            this.currentOrders = this.currentOrders.map(o => ({
              ...o,
              isReferenceNumberSend: true,
              referenceNo: ref,
            }));
            this.$store.state.dialog = true;
            this.$store.state.message = "Referans numarası başarıyla gönderildi.";
          } else {
            this.$store.state.dialog = true;
            this.$store.state.message = "Referans numarası gönderilirken hata oluştu.";
          }
          return;
        }

        this.referenceSent = true;
        this.currentOrders = this.currentOrders.map(o => ({
          ...o,
          referenceNo: ref,
        }));
        this.$store.state.dialog = true;
        this.$store.state.message = "Referans numarası eklendi.";
      } finally {
        this.referenceSending = false;
      }
    },

    triggerReceiptInput() {
      if (this.receiptUploading) return;
      if (this.$refs && this.$refs.receiptFileInput) {
        this.$refs.receiptFileInput.click();
      }
    },

    async onReceiptFileSelected(event) {
      const files = event && event.target ? event.target.files : null;
      if (!files || files.length === 0) return;
      const file = files[0];
      if (!this.currentOrders || this.currentOrders.length === 0) return;

      this.receiptUploading = true;
      try {
        const presignedResponse = await Api.post("/api/upload/presigned-url-receipt", {
          fileName: file.name,
          contentType: file.type || "application/octet-stream",
        });
        const { uploadUrl, fileKey } = presignedResponse.data;

        await axios.put(uploadUrl, file, {
          headers: { "Content-Type": file.type || "application/octet-stream" },
        });

        const orderNumber = this.currentOrders[0].orderNumber;
        const saved = await Api.post(`/api/RichOrders/append-receipt/${orderNumber}`, { fileKey });
        const receiptKeys = saved && saved.data ? saved.data : [];

        this.currentOrders = this.currentOrders.map((o) => ({
          ...o,
          receipts: receiptKeys,
        }));

        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont başarıyla yüklendi.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont yüklenirken bir hata oluştu.";
      } finally {
        this.receiptUploading = false;
        if (this.$refs && this.$refs.receiptFileInput) {
          this.$refs.receiptFileInput.value = "";
        }
      }
    },

    getReceiptFileName(fileKey) {
      if (!fileKey) return "";
      const parts = String(fileKey).split("/");
      return parts[parts.length - 1];
    },

    async getReceiptPublicUrl(fileKey) {
      const response = await Api.get("/api/upload/public-url", { params: { fileKey } });
      return response && response.data ? response.data.url : null;
    },

    async copyReceiptLink(fileKey) {
      try {
        const url = await this.getReceiptPublicUrl(fileKey);
        if (!url) {
          this.$store.state.dialog = true;
          this.$store.state.message = "Dekont linki oluşturulamadı.";
          return;
        }
        await navigator.clipboard.writeText(url);
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont linki kopyalandı.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont linki kopyalanamadı.";
      }
    },

    async openReceipt(fileKey) {
      if (!fileKey) return;
      try {
        const url = await this.getReceiptPublicUrl(fileKey);
        if (!url) {
          this.$store.state.dialog = true;
          this.$store.state.message = "Dekont linki oluşturulamadı.";
          return;
        }
        window.open(url, "_blank");
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont açılırken bir hata oluştu.";
      }
    },

    async deleteReceipt(fileKey) {
      if (!fileKey) return;
      if (!this.currentOrders || this.currentOrders.length === 0) return;
      if (this.receiptUploading) return;

      const ok = window.confirm(
        "Dekont silinsin mi?\n\nDekont zorunlu olduğu için, siparişi tamamlamak için tekrar dekont yüklemeniz gerekebilir."
      );
      if (!ok) return;

      this.$set(this.receiptDeleting, fileKey, true);
      try {
        const orderNumber = this.currentOrders[0].orderNumber;
        const response = await richOrdersApi.removeReceipt(orderNumber, fileKey);
        const receiptKeys = (response && response.data) ? response.data : [];

        this.currentOrders = this.currentOrders.map((o) => ({
          ...o,
          receipts: receiptKeys,
        }));

        this.$store.state.dialog = true;
        this.$store.state.message = "Dekont silindi.";
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          (error.response && error.response.data && error.response.data.message) ||
          "Dekont silinirken bir hata oluştu.";
      } finally {
        this.$set(this.receiptDeleting, fileKey, false);
      }
    },

    async search() {
      this.loading = true;
      try {
        let isEligibleForCompletion = null;
        if (this.selectedEligibility && this.selectedEligibility.id === 'eligible') {
          isEligibleForCompletion = true;
        } else if (this.selectedEligibility && this.selectedEligibility.id === 'not-eligible') {
          isEligibleForCompletion = false;
        }

        const searchDto = {
          startDate: this.startDate,
          endDate: this.endDate,
          searchQuery: this.searchQuery,
          orderState: this.selectedOrderState && this.selectedOrderState.id !== -1 ? this.selectedOrderState.id : null,
          mpOrderStatus: this.selectedMpStatus && this.selectedMpStatus.id ? this.selectedMpStatus.id : null,
          bankName: this.selectedBank && this.selectedBank.id !== '-1' ? this.selectedBank.id : null,
          isEligibleForCompletion: isEligibleForCompletion
        };
        await this.$store.dispatch('richOrders/searchRichOrders', searchDto);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error searching rich orders:', error);
        this.$store.state.dialog = true;
        this.$store.state.message = 'Arama sırasında bir hata oluştu.';
      } finally {
        this.loading = false;
      }
    },

    async processOrder(order) {
      try {
        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', order.orderNumber);
        this.currentOrders = orderDetails;
        this.fraudFlagActive = orderDetails.some(item => item.isSentForFraud);
        this.bankCashDeductionAmount = null;
        const existingRef = (orderDetails && orderDetails.length && orderDetails[0].referenceNo) ? String(orderDetails[0].referenceNo).trim() : "";
        this.referenceNumber = existingRef;
        if (this.isReferenceRequired) {
          this.referenceSent = !!(orderDetails && orderDetails.length && orderDetails[0].isReferenceNumberSend);
        } else {
          this.referenceSent = !!existingRef;
        }
        this.orderDialog = true;
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Bu sipariş başka bir kullanıcı tarafından işlem görüyor.';
      }
    },

    async closeModal() {
      if (this.currentOrders && this.currentOrders.length > 0) {
        this.closeLoading = true;
        try {
          await this.$store.dispatch('richOrders/unlockOrder', this.currentOrders[0].orderNumber);
          await this.search();
          this.currentOrders = [];
        } catch (error) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Modal kapatılırken bir hata oluştu.';
        } finally {
          this.closeLoading = false;
          this.orderDialog = false;
          this.bankCashDeductionAmount = null;
          this.referenceNumber = "";
          this.referenceSent = false;
          this.referenceSending = false;
          this.receiptDeleting = {};
        }
      }
    },

    onDialogChange(val) {
      if (!val && this.currentOrders && this.currentOrders.length > 0) {
        this.closeModal();
      }
    },

    async loadBanks() {
      try {
        await this.$store.dispatch('richOrders/loadActiveBanks');
        const activeBanks = this.$store.getters['richOrders/activeBanks'];
        this.bankOptions = [
          { id: '-1', value: 'Tümü' },
          ...activeBanks.map(b => ({ id: b.bankName, value: b.bankName }))
        ];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading banks:', error);
      }
    },

    getNoteColor(note) {
      if (note.includes('Anlaşmalı Banka') && !note.includes('Değil')) return 'green';
      return 'grey';
    },

    async copyIbanToClipboard(iban) {
      try {
        await navigator.clipboard.writeText(iban);
        this.$store.state.dialog = true;
        this.$store.state.message = `IBAN kopyalandı: ${iban}`;
      } catch (error) {
        const textArea = document.createElement('textarea');
        textArea.value = iban;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$store.state.dialog = true;
          this.$store.state.message = `IBAN kopyalandı: ${iban}`;
        } catch (err) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'IBAN kopyalanamadı. Lütfen manuel olarak kopyalayın.';
        }
        document.body.removeChild(textArea);
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    async setShippingStatus() {
      if (!this.currentOrders || this.currentOrders.length === 0) return;

      if (!this.isCashDeductionValid) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Tamamlamak için "Nakit Düşümü (TL)" alanını doldurunuz.';
        return;
      }

      this.shippingLoading = true;
      try {
        const poolOrders = this.currentOrders.map(order => ({
          id: order.id,
          indicator: 0,
          orderDate: order.orderDateTime,
          identityNo: '',
          shipmentNo: order.orderNumber,
          recipientName: order.customerName,
          productName: order.productName,
          quantity: order.quantity,
          amount: order.unitPrice,
          totalAmount: order.invoiceAmount,
          barcode: '',
          iban: order.ibanFull
        }));

        await this.$store.dispatch('richOrders/completeBulkOrder', poolOrders);

        const bankName = this.currentOrders[0].bankName;
        const cashAmount = Number(this.bankCashDeductionAmount);
        const updated = await this.$store.dispatch('partnerBanks/cashAmountUpdate', { bankName, cashAmount });
        if (!updated) {
          throw new Error('Bank cash amount update failed.');
        }

        await this.$store.dispatch('richOrders/unlockOrder', this.currentOrders[0].orderNumber);
        await this.search();

        this.$store.state.dialog = true;
        this.$store.state.message = 'Sipariş başarıyla tamamlandı.';

        this.currentOrders = [];
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Sipariş tamamlanırken bir hata oluştu.';
      } finally {
        this.shippingLoading = false;
        this.orderDialog = false;
        this.bankCashDeductionAmount = null;
      }
    },

    initIbanUpdateState(orderItemId) {
      if (!this.ibanUpdateState[orderItemId]) {
        this.$set(this.ibanUpdateState, orderItemId, {
          showInput: false,
          newIban: '',
          loading: false
        });
      }
    },

    showIbanInput(orderItemId, currentIban) {
      this.initIbanUpdateState(orderItemId);
      const current = (currentIban || "").trim();
      if (current) {
        this.ibanUpdateState[orderItemId].newIban = current;
      }
      this.ibanUpdateState[orderItemId].showInput = true;
    },

    async updateItemIban(item) {
      const orderItemId = item.orderItemId;
      this.initIbanUpdateState(orderItemId);

      const state = this.ibanUpdateState[orderItemId];
      const newIban = state.newIban.trim();

      if (!newIban) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Lütfen yeni IBAN giriniz.';
        return;
      }

      if (newIban.length !== 26) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'IBAN 26 karakter olmalıdır.';
        return;
      }

      state.loading = true;
      try {
        await this.$store.dispatch('richOrders/updateOrderItemIban', {
          orderItemId,
          newIban
        });

        this.$store.state.dialog = true;
        this.$store.state.message = 'IBAN başarıyla güncellendi.';

        const orderNumber = this.currentOrders[0].orderNumber;
        await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
        await this.search();

        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
        this.currentOrders = orderDetails;
        this.ibanUpdateState = {};

      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'IBAN güncellenirken bir hata oluştu.';
      } finally {
        state.loading = false;
      }
    },

    initNotesUpdateState(orderItemId) {
      if (!this.notesUpdateState[orderItemId]) {
        this.$set(this.notesUpdateState, orderItemId, {
          showTextarea: false,
          notes: '',
          loading: false
        });
      }
    },

    showNotesTextarea(orderItemId, currentNotes) {
      this.initNotesUpdateState(orderItemId);
      this.notesUpdateState[orderItemId].notes = currentNotes || '';
      this.notesUpdateState[orderItemId].showTextarea = true;
    },

    async updateItemNotes(item) {
      const orderItemId = item.orderItemId;
      this.initNotesUpdateState(orderItemId);

      const state = this.notesUpdateState[orderItemId];
      const notes = state.notes.trim();

      state.loading = true;
      try {
        await this.$store.dispatch('richOrders/updateOrderItemNotes', {
          orderItemId,
          notes
        });

        this.$store.state.dialog = true;
        this.$store.state.message = 'Not başarıyla kaydedildi.';

        const orderNumber = this.currentOrders[0].orderNumber;
        await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
        await this.search();

        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
        this.currentOrders = orderDetails;
        this.notesUpdateState = {};

      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Not kaydedilirken bir hata oluştu.';
      } finally {
        state.loading = false;
      }
    },

    async openFraudModal() {
      this.fraudDialog = true;
      this.fraudLoading = true;
      this.emailPrepared = false;
      this.fraudOrders = [];
      try {
        this.fraudOrders = await this.$store.dispatch('richOrders/getFraudOrders');
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Fraud siparişleri yüklenirken bir hata oluştu.';
        // eslint-disable-next-line no-console
        console.error('Error loading fraud orders:', error);
      } finally {
        this.fraudLoading = false;
      }
    },

    closeFraudModal() {
      this.fraudDialog = false;
      this.fraudOrders = [];
      this.fraudLoading = false;
      this.emailPrepared = false;
    },

    openExcelModal() {
      this.excelDialog = true;
      const today = new Date().toISOString().substr(0, 10);
      this.excelStartDate = today;
      this.excelEndDate = today;
    },

    closeExcelModal() {
      this.excelDialog = false;
      this.excelStartDate = null;
      this.excelEndDate = null;
      this.excelLoading = false;
    },

    async exportToExcel() {
      if (!this.excelStartDate || !this.excelEndDate) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Lütfen başlangıç ve bitiş tarihlerini seçin.';
        return;
      }

      this.excelLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getCompletedOrdersForExport', {
          startDate: this.excelStartDate,
          endDate: this.excelEndDate
        });

        if (!data || data.length === 0) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Seçilen tarih aralığında tamamlanmış sipariş bulunamadı.';
          return;
        }

        const XLSX = require('xlsx');

        const excelData = data.map(item => ({
          'Sipariş Tarihi': new Date(item.orderDateTime).toLocaleString('tr-TR'),
          'Tamamlanma Tarihi': item.completedDate ? new Date(item.completedDate).toLocaleString('tr-TR') : '',
          'Sipariş Numarası': item.orderNumber,
          'Müşteri Adı': item.customerName,
          'IBAN': item.ibanFull,
          'Banka': item.bankName || '',
          'Ürün Adı': item.productName,
          'Miktar': item.quantity,
          'Sipariş Gram': item.orderGrams,
          'Bankaya Gönderilecek Gram': parseFloat(item.gramsToSendToBank).toFixed(2),
          'Birim Fiyat': item.unitPrice,
          'Fatura Tutarı': item.invoiceAmount,
          'Sipariş Durumu': this.getStateValue(item.orderState),
          'MP Sipariş Durumu': this.getMpOrderStatusValue(item.mpOrderStatus)
        }));

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Siparişler');

        const fileName = `Siparis_Raporu_${this.excelStartDate}_${this.excelEndDate}.xlsx`;

        XLSX.writeFile(wb, fileName);

        this.$store.state.dialog = true;
        this.$store.state.message = 'Excel raporu başarıyla oluşturuldu.';
        this.closeExcelModal();

      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Excel raporu oluşturulurken bir hata oluştu.';
        // eslint-disable-next-line no-console
        console.error('Error exporting to Excel:', error);
      } finally {
        this.excelLoading = false;
      }
    },

    prepareEmail() {
      if (this.fraudOrders.length === 0) return;

      const orderNumbers = this.fraudOrders.map(fo => fo.orderNumber).join('\n');
      const subject = 'Kontrol edilecek siparişler';
      const body = `Merhaba,\n\nAşağıdaki sipariş numaralarının kontrol edilmesi gerekmektedir:\n\n${orderNumbers}\n\nTeşekkürler.`;

      const mailtoLink = `mailto:fraud@hepsiburada.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;

      this.emailPrepared = true;
    },

    async markAsSent() {
      try {
        const orderNumbers = [];
        for (let i = 0; i < this.fraudOrders.length; i++) {
          orderNumbers.push(this.fraudOrders[i].orderNumber);
        }

        const richOrdersApi = require('@/api/richOrders').default;
        await richOrdersApi.markFraudSent(orderNumbers);

        this.$store.state.dialog = true;
        this.$store.state.message = 'Siparişler fraud olarak işaretlendi.';

        this.closeFraudModal();
        await this.search();
      } catch (error) {
        this.$store.state.dialog = true;
        const errorMessage = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'Siparişler işaretlenirken bir hata oluştu.';
        this.$store.state.message = errorMessage;
        // eslint-disable-next-line no-console
        console.error('Error marking orders as sent for fraud:', error);
        // eslint-disable-next-line no-console
        console.error('Error response:', error.response);
      }
    },

    async handleFraudSwitchChange(value) {
      if (!value) {
        try {
          const orderNumber = this.currentOrders[0].orderNumber;
          // eslint-disable-next-line no-console
          console.log('Clearing fraud flag for orderNumber:', orderNumber, 'Type:', typeof orderNumber);

          await this.$store.dispatch('richOrders/clearFraudFlag', orderNumber);

          this.$store.state.dialog = true;
          this.$store.state.message = 'Fraud işareti kaldırıldı.';

          await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
          await this.search();

          const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
          this.currentOrders = orderDetails;
          this.fraudFlagActive = false;

        } catch (error) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Fraud işareti kaldırılırken bir hata oluştu.';
          // eslint-disable-next-line no-console
          console.error('Error clearing fraud flag:', error);
          this.fraudFlagActive = true;
        }
      }
    },

    getStateValue(stateId) {
      const stateMap = {
        0: 'Yeni Sipariş',
        1: 'İşleniyor',
        2: 'Tamamlandı',
        3: 'İptal Edildi',
        4: 'İade'
      };
      return stateMap[stateId] || stateId.toString();
    },

    getMpOrderStatusValue(mpStatus) {
      if (!mpStatus) return '';
      const hbStateItems = this.$store.getters['orders/getHbStateItems'];
      const result = hbStateItems.find(el => el.id === mpStatus);
      return result ? result.value : mpStatus;
    }
  }
};
</script>

<style scoped>
.grey.lighten-3 {
  opacity: 0.6;
}

.square-chip {
  border-radius: 0 !important;
}

.clickable-iban {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
}

.clickable-iban:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.clickable-iban:active {
  transform: translateY(0);
}

.order-modal .v-card__title {
  position: sticky;
  top: 0;
  z-index: 1;
}

.order-modal .caption {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.order-modal .body-2 {
  margin-top: 4px;
}

.order-modal .v-card {
  transition: all 0.3s ease;
}

.order-modal .v-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ro-row:hover {
  background: rgba(248, 250, 252, 0.9);
}

.ro-row-danger {
  background: rgba(254, 242, 242, 0.55);
}

.ro-customer-name {
  font-weight: 700;
  font-size: 13px;
  color: #0f172a;
}

.ro-customer-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
  word-break: break-word;
}

.ro-customer-mono {
  font-size: 11px;
  margin-top: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  color: #334155;
}

.ro-iban {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ro-iban-chip {
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 8px;
  width: fit-content;
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
  cursor: pointer;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.ro-bank-pill {
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  width: fit-content;
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.ro-bank-ok {
  background: rgba(16, 185, 129, 0.12);
  color: #047857;
  border-color: rgba(16, 185, 129, 0.25);
}

.ro-bank-missing {
  background: rgba(148, 163, 184, 0.12);
  color: #64748b;
  border-color: rgba(148, 163, 184, 0.25);
  font-style: italic;
}

.ro-order-mono {
  font-size: 11px;
  color: #64748b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.ro-order-sub {
  font-size: 12px;
  margin-top: 4px;
  color: #334155;
}

.ro-strong {
  font-weight: 700;
}

.ro-product {
  font-size: 12px;
  line-height: 1.35;
  max-width: 220px;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #0f172a;
}

.ro-product-sub {
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
}

.ro-amount-main {
  font-weight: 700;
  font-size: 13px;
  color: #0f172a;
}

.ro-amount-sub {
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}

.ro-total {
  font-weight: 800;
  font-size: 13px;
  color: #0f172a;
}

.ro-status {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ro-status-pill {
  font-size: 11px;
  font-weight: 700;
  padding: 0;
  border-radius: 0;
  width: auto;
  border: none;
  background: transparent;
  color: #0f172a;
}

.ro-status-cargo {
  background: transparent;
  color: #0f172a;
  border: none;
}

.ro-status-mp {
  background: transparent;
  color: #0f172a;
  border: none;
}

.ro-completed {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ro-completed-by {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

.ro-completed-date {
  font-size: 11px;
  color: #64748b;
}

.ro-success-rate {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.8rem;
}
.ro-success-ok {
  color: #059669;
  font-weight: 600;
}
.ro-success-fail {
  color: #dc2626;
  font-weight: 600;
}
.ro-muted {
  color: #94a3b8;
  font-weight: 600;
}

.ro-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0.55;
  transition: opacity 160ms ease;
}

.ro-row:hover .ro-actions {
  opacity: 1;
}

.ro-action-btn {
  border: none;
  background: transparent;
  padding: 6px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 160ms ease, transform 160ms ease;
}

.ro-action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ro-action-btn:hover {
  transform: translateY(-1px);
}

.ro-action-blue {
  color: #2563eb;
}

.ro-action-blue:hover {
  background: rgba(37, 99, 235, 0.10);
}

.ro-action-green {
  color: #059669;
}

.ro-action-green:hover {
  background: rgba(5, 150, 105, 0.10);
}

.ro-action-orange {
  color: #f59e0b;
}

.ro-action-orange:hover {
  background: rgba(245, 158, 11, 0.12);
}

.ro-locked-by {
  margin-top: 6px;
  font-size: 11px;
  color: #94a3b8;
  text-align: center;
}

.note-display-card {
  background-color: #f5f5f5;
  border-left: 4px solid #1976d2 !important;
}

.note-display-card .body-2 {
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.note-edit-btn {
  position: absolute !important;
  top: 4px;
  right: 4px;
}

.order-modal .modern-card {
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.26) !important;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
  overflow: hidden;
}

.order-modal .modern-card:hover {
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.10) !important;
  transform: translateY(-1px);
}

.order-modal .modern-subcard {
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.22) !important;
  background: rgba(248, 250, 252, 0.9) !important;
}

.order-modal .modern-dashed-card {
  min-width: 360px;
  max-width: 420px;
  border-radius: 16px;
  border: 2px dashed rgba(29, 78, 216, 0.45) !important;
  background: rgba(29, 78, 216, 0.04) !important;
  box-shadow: 0 10px 22px rgba(29, 78, 216, 0.10) !important;
}

@media (max-width: 600px) {
  .order-modal .modern-dashed-card {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0 !important;
    margin-bottom: 12px;
  }
}

.receipt-shell {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.receipt-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  background: #fff;
}

.receipt-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.receipt-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(25, 118, 210, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
}

.receipt-title {
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
}

.receipt-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.receipt-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.12);
  color: #047857;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.receipt-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #10b981;
  animation: receiptPulse 1.6s infinite;
}

@keyframes receiptPulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.25);
    opacity: 0.55;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.receipt-body {
  padding: 20px;
  background: #fff;
}

.receipt-section-title {
  font-weight: 700;
  font-size: 14px;
  color: #0f172a;
}

.receipt-section-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.receipt-ref-btn {
  height: 40px;
}

.receipt-success {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  color: #059669;
  font-size: 12px;
}

.receipt-dropzone {
  margin-top: 10px;
  width: 100%;
  cursor: pointer;
  border: 2px dashed rgba(25, 118, 210, 0.35);
  background: rgba(25, 118, 210, 0.03);
  border-radius: 16px;
  padding: 22px 16px;
  text-align: center;
  transition: all 160ms ease;
}

.receipt-dropzone:hover {
  border-color: rgba(25, 118, 210, 0.65);
  background: rgba(25, 118, 210, 0.06);
  transform: translateY(-1px);
}

.receipt-dropzone-icon {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 22px rgba(29, 78, 216, 0.25);
  margin-bottom: 10px;
}

.receipt-dropzone-title {
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #0f172a;
}

.receipt-dropzone-desc {
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
}

.receipt-count-pill {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 10px;
  background: #10b981;
  color: #fff;
  font-weight: 700;
  box-shadow: 0 10px 18px rgba(16, 185, 129, 0.20);
}

.receipt-list-shell {
  border-radius: 16px;
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.22);
  overflow: hidden;
}

.receipt-list-header {
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
}

.receipt-list-title {
  font-weight: 800;
  color: #0f172a;
}

.receipt-list-hint {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.receipt-items {
  display: block;
}

.receipt-item {
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  background: transparent;
  transition: background 160ms ease;
}

.receipt-item:last-child {
  border-bottom: none;
}

.receipt-item:hover {
  background: rgba(255, 255, 255, 0.65);
}

.receipt-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.receipt-file-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(29, 78, 216, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.receipt-file-meta {
  min-width: 0;
}

.receipt-file-name {
  font-weight: 700;
  color: #0f172a;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 520px;
}

.receipt-item-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.receipt-icon-btn {
  background: transparent !important;
}

.receipt-open-btn {
  background: #fff !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  color: #1d4ed8 !important;
  font-weight: 800;
  border-radius: 10px;
  height: 34px;
  padding: 0 10px;
  box-shadow: 0 6px 10px rgba(15, 23, 42, 0.06);
  transition: all 160ms ease;
}

.receipt-open-btn:hover {
  background: #1d4ed8 !important;
  color: #fff !important;
  border-color: #1d4ed8 !important;
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(29, 78, 216, 0.22);
}

.receipt-open-text {
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.05em;
}

.ref-shell {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  padding: 16px;
}

.ref-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.ref-header-icon {
  color: #f48c25 !important;
}

.ref-header-title {
  font-size: 16px;
  font-weight: 800;
  color: #1c140d;
  letter-spacing: 0.02em;
}

.ref-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.ref-label {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 220px;
}

.ref-label-text {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 6px;
}

.ref-input-wrap {
  position: relative;
}

.ref-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af !important;
  transition: color 160ms ease;
}

.ref-input {
  width: 100%;
  height: 52px;
  padding-left: 44px;
  padding-right: 14px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #111827;
  outline: none;
  transition: box-shadow 160ms ease, border-color 160ms ease, background 160ms ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.ref-input:focus {
  border-color: #f48c25;
  box-shadow: 0 0 0 3px rgba(244, 140, 37, 0.22);
  background: #fff;
}

.ref-input:focus+.ref-input-icon {
  color: #f48c25 !important;
}

.ref-input:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.ref-send-btn {
  height: 52px;
  padding: 0 18px !important;
  background: #f48c25 !important;
  border-radius: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.04em;
  box-shadow: 0 10px 18px rgba(244, 140, 37, 0.22);
  min-width: 160px;
}

.ref-send-btn:hover {
  filter: brightness(0.96);
}

.ref-send-text {
  font-weight: 900;
}

.ref-footnote {
  margin-top: 10px;
  font-size: 11px;
  color: #6b7280;
}

.ref-success {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
  color: #059669;
}

@media (max-width: 600px) {
  .receipt-item {
    flex-direction: column;
    align-items: stretch;
  }

  .receipt-item-actions {
    justify-content: flex-end;
  }

  .receipt-file-name {
    max-width: 100%;
  }

  .ref-send-btn {
    width: 100%;
    min-width: 0;
  }
}
</style>